<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="relative flex items-center">
        <button
        class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
        (click)="goback()">
        <mat-icon
            class="w-[5px] mr-[1px] h-[3px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
            svgIcon="icons:arrow-icon">
        </mat-icon>
        </button>
        <h1 class=" text-primary-black-01 title-6 md:title-3">Reportes Pagarés</h1>
    </div>

    <div class="flex flex-col items-center justify-center w-full pt-5 pb-5 md:flex-row md:gap-5">
        <mat-form-field class="w-full md:flex-1 mt-6">
            <input
                matInput
                placeholder="Ingrese RUT"
                class="py-[18px]"
                [(ngModel)]="search"
                [patterns]="customPatterns"
                mask="0*"
                [dropSpecialCharacters]="false"
                maxlength="30"
                (keyup.enter)="buscar()" />
            <mat-icon class="w-[16.67px] h-[15px] min-w-[16.67px] min-h-[15px] cursor-pointer" svgIcon="icons:buscar-icon" (click)="buscar()"> </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full md:w-72">
            <mat-label>Estado pagaré</mat-label>
            <mat-select class="h-[54px]" [(ngModel)]="estadoSelected" (selectionChange)="listar()">
                <mat-option *ngFor="let estado of estadosPagare" [value]="estado.ID_ESTADO">
                    {{ estado.NOMBRE_ESTADO || 'Seleccione' }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full md:w-72">
            <mat-label class="px-1">Desde &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Hasta</mat-label>
            <mat-date-range-input [rangePicker]="picker" class="py-[15px] title-9 font-semibold">
                <input matStartDate placeholder="Fecha inicio" [(ngModel)]="start" #dateRangeStart />
                <input
                    matEndDate
                    placeholder="Fecha fin"
                    [(ngModel)]="end"
                    #dateRangeEnd
                    (dateChange)="dateRangeChange($event, dateRangeStart, dateRangeEnd)" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>

    <button
        mat-flat-button
        color="primary"
        class="w-full mt-10 transition-all duration-300 ease-in-out md:hidden"
        >
        Descargar
    </button>

    <!-- TABLE DESKTOP -->
    <app-mat-custom-table
    [use_selection]="false"
    [use_detail]="false"
    [selection]="selection"
    [dataset]="dataSource"
    [columns]="columns"
    >
    </app-mat-custom-table>

    <div class="grid grid-cols-1 gap-5 pt-5 md:px-5 md:grid-cols-2 md:gap-0">
        <button mat-flat-button color="primary" class="w-full transition-all duration-300 ease-in-out md:w-36" (click)="descargarExcel()">
            Descargar
        </button>
    </div>
</main>
